
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.748 7.053a.75.75 0 00-1.496-.106l1.496.106zm-1.615 12.09l-.748-.054.748.053zm-12.266 0l.748-.054-.748.053zM5.748 6.946a.75.75 0 10-1.496.106l1.496-.106zM10.75 11a.75.75 0 00-1.5 0h1.5zm-1.5 6a.75.75 0 001.5 0h-1.5zm5.5-6a.75.75 0 00-1.5 0h1.5zm-1.5 6a.75.75 0 001.5 0h-1.5zm1-10a.75.75 0 001.5 0h-1.5zm-6 0a.75.75 0 001.5 0h-1.5zM4 6.25a.75.75 0 000 1.5v-1.5zm16 1.5a.75.75 0 000-1.5v1.5zm-1.748-.803l-.867 12.142 1.496.107.867-12.143-1.496-.106zM16.138 20.25H7.862v1.5h8.276v-1.5zm-9.523-1.16L5.748 6.946l-1.496.106.867 12.143 1.496-.107zm1.247 1.16a1.25 1.25 0 01-1.247-1.16l-1.496.106a2.75 2.75 0 002.743 2.554v-1.5zm9.523-1.16a1.25 1.25 0 01-1.247 1.16v1.5a2.75 2.75 0 002.743-2.554l-1.496-.107zM9.25 11v6h1.5v-6h-1.5zm4 0v6h1.5v-6h-1.5zM10 3.75h4v-1.5h-4v1.5zm4.25.25v3h1.5V4h-1.5zm-4.5 3V4h-1.5v3h1.5zM14 3.75a.25.25 0 01.25.25h1.5A1.75 1.75 0 0014 2.25v1.5zm-4-1.5A1.75 1.75 0 008.25 4h1.5a.25.25 0 01.25-.25v-1.5zm-6 5.5h16v-1.5H4v1.5z"}})])
          )
        }
      }
    